module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"allCountries":"Alle Länder","title":"Management Team"},"en":{"allCountries":"All countries","title":"Management team"},"it":{"allCountries":"","title":""},"lt":{"allCountries":"Visos šalys","title":"Vadovybė"},"pl":{"allCountries":"Wszystkie kraje","title":"Nasz zespół"}}')
  delete Component.options._Ctor
}
